var exports = {
  "U": "x24da60e8--74172c--wide",
  "vb": "x24da60e8--74172c--curtain",
  "wx": "x24da60e8--74172c--header",
  "Qs": "x24da60e8--74172c--content",
  "R_": "x24da60e8--74172c--heading",
  "FY": "x24da60e8--74172c--paragraph",
  "p_": "x24da60e8--74172c--list",
  "x3": "x24da60e8--74172c--list-item",
  "qr": "x24da60e8--74172c--footer",
  "SJ": "x24da60e8--74172c--cancel-button",
  "o3": "x24da60e8--74172c--accept-button",
};

module.exports = exports;
